import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-basic-infomation",
  "use": "app-icon-basic-infomation-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-basic-infomation\"><g transform=\"translate(3 3)\" fill-rule=\"evenodd\"><path d=\"M9 18A9 9 0 119 0a9 9 0 010 18zm0-1.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z\" /><circle cx=\"9\" cy=\"4.75\" r=\"1\" /><path d=\"M8.25 7h1.5v7h-1.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol